import { EventBus } from "../../../eventbus";

export default {
  props: {
    show: Boolean,
    placeholder: String,
    properties: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      inputVal: "",
      searchResults: null,
      showSearchResult: false,
    };
  },
  created() {
    EventBus.$on("search-results-count", (count) => {
      this.searchResults = count;
    });
  },
  methods: {
    startSearch(e) {
      if (this.inputVal !== "") {
        //start search
        EventBus.$emit("search", {
          value: this.inputVal,
        });

        //display
        this.showSearchResult = true;
      }
    },

    clearSearch(e) {
      //wipe input
      this.inputVal = "";

      //hide
      this.showSearchResult = false;

      //send event
      EventBus.$emit("search-clear", {});
    },
  },

  watch: {
    show(newShow) {
      if (this.$refs.searchInput) {
        if (newShow) {
          this.$refs.searchInput.focus();
        } else {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.blur();
          }
        }
      }
    },
  },
};
